import { useGridApiContext, GridRenderEditCellParams } from '@mui/x-data-grid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ClickOpenDatePicker, ClickOpenDateTimePicker } from './ClickOpenPickers';

import { dayjs, getAppTimeZone, stripTimeZoneFromFormat } from 'utils/DateUtils';
import { ENV_CONFIG } from 'config/env';
/**
 * `date` column
 */
/**
 * `dateTime` column
 */

const textInputStyles = {
  px: 1,
  '& .MuiOutlinedInput': {
    padding: '1px 2px',
  },
  '& .MuiOutlinedInput-input': {
    padding: '2px 5px',
  },
};

function getDatePickerInputFormat(type?: string) {
  if (type === 'dateTime') {
    return stripTimeZoneFromFormat(ENV_CONFIG.config.DATE_TIME_FORMAT);
  }
  return ENV_CONFIG.config.DATE_FORMAT;
}

interface CustomGridEditDateCellParams extends GridRenderEditCellParams<Date | string | null> {
  isRequired?: boolean;
}

export function GridEditDateCell({ id, field, value, colDef, isRequired }: CustomGridEditDateCellParams) {
  const apiRef = useGridApiContext();

  const errorMessage = isRequired && !value ? 'This field is required' : '';

  const Component = colDef.type === 'dateTime' ? ClickOpenDateTimePicker : ClickOpenDatePicker;

  const inputFormat = getDatePickerInputFormat(colDef.type);
  const isDateTime = colDef.type === 'dateTime';

  // v6 renders/edits natively in the given timezone. For dateTime, parse the UTC
  // value into the app timezone so the picker matches the (app-zone) table cell.
  // A value already a Dayjs means the user is mid-edit — keep it as-is.
  const pickerValue =
    isDateTime && value && !dayjs.isDayjs(value) ? dayjs.utc(value).tz(getAppTimeZone()) : value;

  const handleChange = (newValue: unknown) => {
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Component
        value={pickerValue as any}
        format={inputFormat}
        timezone={isDateTime ? getAppTimeZone() : undefined}
        onChange={handleChange}
        slotProps={{
          textField: { sx: textInputStyles, error: !!errorMessage, helperText: errorMessage },
        }}
      />
    </LocalizationProvider>
  );
}
